<template>
  <div class="layout">
    <page-form :formData="formData" @onSubmit="reSearch"></page-form>
    <Row>
      <h1 class='title' style="font-size: 16px;">
        <strong>{{this.$t('performanceQueryTrend.performanceTrend')}}</strong><!-- 绩效趋势 -->
      </h1>
      <Form label-position="left" :label-width="110">
        <Row>
          <Col span="10">
          <FormItem :label="this.$t('performanceQueryTrend.supplierName')"><!-- 供应商名称 -->
            <Input v-model="fromObj.vendorName" readonly></Input>
          </FormItem>
          </Col>
          <Col span="6" offset="1">
          <FormItem :label="this.$t('performanceQueryTrend.category')" :label-width="130"><!-- 采购分类 -->
            <Input v-model="fromObj.categoryCode" readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="10">
          <FormItem :label="this.$t('performanceQueryTrend.organization')"><!-- 库存组织 -->
            <Input v-model="fromObj.organizationName" readonly></Input>
          </FormItem>
          </Col>
          <Col span="6" offset="1">
          <FormItem :label="this.$t('performanceQueryTrend.performanceMouth')" :label-width="130"><!-- 绩效月份 -->
            <Input v-model="fromObj.perfMonth" readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="4">
          <FormItem :label="this.$t('performanceQueryTrend.compPerfScore')"><!-- 绩效总分 -->
            <Input v-model="fromObj.compositeScore" readonly></Input>
          </FormItem>
          </Col>
          <Col span="4" offset="2">
          <FormItem :label="this.$t('performanceQueryTrend.perfRanking')" :label-width="140"><!-- 绩效排名 -->
            <Input v-model="fromObj.compositeRank" readonly></Input>
          </FormItem>
          </Col>
          <Col span="6" offset="1">
          <FormItem :label="this.$t('performanceQueryTrend.supplierNumber')" :label-width="130"><!-- 供应商数量 -->
            <Input v-model="fromObj.vendorCount" readonly></Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
    </Row>
    <Row>
      <div id="trendId" style="width: 100%;height:300px;"></div>
    </Row>
    <Row style="padding-left:60px">
      <Col span='16' offset='10'>
      <m-button type="primary" @click="goBack" style="margin-left:20px">{{this.$t('common.back')}}</m-button><!-- 返回 -->
      </Col>
    </Row>
  </div>
</template>

<script>
  import httpservice from '../../../../utils/http';
  import echarts from 'echarts';
  import PageForm from '@/components/awesome/page/query/index';
  import {formatDateTime} from '@/utils/datetime-format.js';
  export default {
    name: 'performanceQueryTrend',
    components: {PageForm},
    data() {
      return {
        currLang: this.$i18n.locale,
        fromObj: {},
        vendorCode: '',
        // vendorId: '',
        resultSource: {},
        loading: false,
        orgResult: [],
        formData: {
          row: 7,
          items: [
            {
              title: this.$t('performanceQueryTrend.organization'), // 库存组织
              value: '',
              field: 'organizationCode',
              disabled: false,
              layout: {
                span: 12,
                offset: 0,
                row: 1
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              validators: {
                required: {
                  required: true,
                  message: this.$t('common.not_empty_require')
                }
              }
            },
            {
              title: this.$t('performanceQueryTrend.performanceMouth'), // 绩效月份
              field: 'perfMonth',
              layout: {
                span: 6,
                offset: 0,
                row: 1
              },
              methods: {},
              options: {
                type: 'month',
                format: 'yyyy-MM'
              },
              type: 'datePicker',
              validators: {
                required: {
                  required: true,
                  message: this.$t('common.not_empty_require')
                }
              }
            },
            {
              title: this.$t('performanceQueryTrend.category'), // 采购分类
              value: '',
              field: 'categoryCode',
              layout: {
                span: 6,
                offset: 0,
                row: 1
              },
              methods: {
                changed: (item) => {
                }
              },
              options: {
                rows: 1
              },
              type: 'text',
              validators: {
                required: {
                  required: true,
                  message: this.$t('common.not_empty_require')
                }
              }
            }
          ]
        }
      };
    },
    watch: {
      'orgResult': function () {
        this.formData.items[0].options.values = this.orgResult;
      },
      'resultSource': function () {
        let month = [];
        let composite = [];
        let cost = [];
        let business = [];
        let quality = [];
        for (let i = 0; i < this.resultSource.length; i++) {
          month.push(this.resultSource[i].perfMonth);
          composite.push(this.resultSource[i].compositeScore);
          cost.push(this.resultSource[i].costScore);
          business.push(this.resultSource[i].businessScore);
          quality.push(this.resultSource[i].qualityScore);
        }
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('trendId'));
        // 指定图表的配置项和数据
        var option = {
          title: {
            text: this.$t('performanceQueryTrend.trendChart'), // 折线图堆叠
            textStyle: {
              fontSize: 15
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            // data: ['综合绩效', '成本绩效', '品质绩效', '业务绩效']
            data: [this.$t('performanceQueryTrend.compPerformance'), this.$t('performanceQueryTrend.costPerformance'), this.$t('performanceQueryTrend.qualityPerformance'), this.$t('performanceQueryTrend.businessPerformance')]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            data: month
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: this.$t('performanceQueryTrend.compPerformance'), // 综合绩效
              type: 'line',
              data: composite
            },
            {
              name: this.$t('performanceQueryTrend.costPerformance'), // 成本绩效
              type: 'line',
              data: cost
            },
            {
              name: this.$t('performanceQueryTrend.qualityPerformance'), // 品质绩效
              type: 'line',
              data: quality
            },
            {
              name: this.$t('performanceQueryTrend.businessPerformance'), // 业务绩效
              type: 'line',
              data: business
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表.
        console.log('JSON.stringify(option)::', JSON.stringify(option));
        myChart.setOption(option);
      }
    },
    methods: {
      reSearch() {
        if (!this.vendorCode) {
          return;
        }
        let params = {};
        params.organizationCode = this.formData.items[0].value;  // M94;
        params.categoryCode = this.formData.items[2].value;          // CP201403120636;
        let endMonth = this.formData.items[1].value;
        params.endMonth = endMonth ? formatDateTime(new Date(endMonth), 'yyyyMM') : ''; // 202006;
        params.language = this.currLang;
        params.vendorCode = this.vendorCode;                      // A0008370;
        this.resultSource = {};
        httpservice.post('/srmperf/gsc/composite/queryScoreTrend', params).then(res => {
            try {
                this.queryCompositeDetail(params);
                this.loading = false;
                const { status, data, msg: content } = res.data;
                if (status === 0) {
                    this.resultSource = data.list;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content,
                    });
                }
            } catch (err) {
                console.log('err:', err);
            }
        }).catch(() => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
        });
      },
      queryCompositeDetail(params) {
        let params2 = this.objDeepCopy(params);
        let inCategoryCodes = [];
        inCategoryCodes = params2.categoryCode ? params2.categoryCode.split(',') : [];
        let queryParams = {
          orgCode: params.organizationCode,
          perfMonth: params.endMonth,
          inCategoryCodes: inCategoryCodes,    // ["CP201403120636"];
          vendorCode: this.vendorCode,
          language: this.currLang
        };
        httpservice.post('/gscint/composite/queryCompositeDetail', queryParams).then(res => {
            try {
              let data = res.data.data;
                if (data.success === true) {
                    this.fromObj = data.datas.list[0];
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: data.msg
                    });
                }
            } catch (err) {
                console.log('err:', err);
            }
        }).catch(() => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
        });
      },
      goBack() {
        this.$router.push({path: '/performance/performanceQueryView'});
      },
      /** 深拷贝 */
      objDeepCopy: function (source) {
          var sourceCopy = source instanceof Array ? [] : {};
          for (var item in source) {
              if (typeof source[item] === 'object') {
                  if (source[item] === null) {
                      sourceCopy[item] = null;
                  } else {
                      sourceCopy[item] = this.objDeepCopy(source[item]);
                  }
              } else {
                  sourceCopy[item] = source[item];
              }
          }
          return sourceCopy;
      },
      getOrganizationName() {
        return httpservice.get('/gscint/vendor/getInvLovTwo?UP=Y&SITE=Y&ASL=Y&labelName=organizationName&valueName=organizationCode').then(res => {
          this.orgResult = res.data.data;
        });
      }
    },
    mounted() {
      this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      this.getOrganizationName();
      this.fromObj = JSON.parse(this.$route.query.row);
      let month = this.fromObj.perfMonth;
      this.fromObj.perfMonth = month ? month.substring(0, 4) + '-' + month.substring(4, 6) : '';
      this.formData.items[0].value = this.fromObj.organizationCode;
      this.formData.items[1].value = this.fromObj.perfMonth; // '2019-09
      this.formData.items[2].value = this.fromObj.categoryCode;
      this.reSearch();
    }
  };
</script>


<style scoped lang='less'>
  .layout {
    margin: 10px;
    padding: 20px;
    background-color: #fff;
    .title {
      margin-bottom: 30px;
      width: 400px;
    }
    /deep/ .m-form-label-left .m-form-item-label {
      text-align: right;
    }
  }
</style>
